import * as React from "react";
import "./styles.scss";
import { Menu, Modal, Segment } from "semantic-ui-react";
import { SOCIAL_NETWORK_METADATA, SocialNetworksId } from "../../../../interfaces";
import { PlayerCard } from "../../../../services/bedrock";
import Instructions from "./Instructions";
import { useContext } from "react";
import { URLS } from "../../../../utils";
import { PlayerCardSettingsContext } from "../../Contexts";

interface LinkToSocialMediaModalProps {
  open: boolean;
  playerCard: PlayerCard;
  onClose: () => void;
}

const LinkToSocialMediaModal: React.FC<LinkToSocialMediaModalProps> = ({ open, playerCard, onClose }) => {
  const {
    SocialNetworkSettings: { socialNetworkSettings },
  } = useContext(PlayerCardSettingsContext);
  const [tabs, setTabs] = React.useState<SocialNetworksId[]>([]);
  const [activeTab, setActiveTab] = React.useState<SocialNetworksId>();

  React.useEffect(() => {
    const newTabs: SocialNetworksId[] = [];
    const possibleTabs: SocialNetworksId[] = ["FB", "IG", "LI", "TW", "TT"];
    possibleTabs.forEach(socialNetworkId => {
      const settings = socialNetworkSettings[socialNetworkId];
      if (settings?.isPermitted && settings.socialNetwork) {
        newTabs.push(socialNetworkId);
      }
    });

    setTabs(newTabs);
    if (!activeTab || !newTabs.includes(activeTab)) {
      setActiveTab(newTabs[0]);
    }
  }, [socialNetworkSettings]);

  return (
    <Modal open={open} size="small" className="playerCardLinkToSocialMediaModal" onClose={() => onClose()} closeIcon>
      <Modal.Header>Link to Social Media</Modal.Header>
      <Modal.Content>
        {tabs.length === 0 && (
          <p>
            You have no social media accounts linked to your account. Go to your{" "}
            <a href={URLS.player.settingsSocialNetworks} target="_blank">
              settings
            </a>{" "}
            to connect them.
          </p>
        )}
        {tabs.length > 0 && (
          <>
            <Menu tabular attached="top">
              {tabs.map((tab: SocialNetworksId) => {
                return (
                  <Menu.Item
                    key={tab}
                    content={SOCIAL_NETWORK_METADATA[tab].name}
                    active={activeTab === tab}
                    onClick={() => setActiveTab(tab)}
                  />
                );
              })}
            </Menu>

            <Segment attached="bottom">
              {activeTab && socialNetworkSettings[activeTab]?.socialNetwork && (
                <Instructions
                  playerCardUrl={`${playerCard.baseUrl}${playerCard.slug}`}
                  socialNetwork={socialNetworkSettings[activeTab].socialNetwork}
                />
              )}
            </Segment>
          </>
        )}
      </Modal.Content>
    </Modal>
  );
};
export default LinkToSocialMediaModal;
